import { registerPlugin } from '@capacitor/core';

import type { JustWeiApkUpdaterPlugin } from './definitions';
import { JustWeiApkUpdaterWeb } from './web';


const JustWeiApkUpdater = registerPlugin<JustWeiApkUpdaterPlugin>(
  'JustWeiApkUpdater',
  {
    web: () => new JustWeiApkUpdaterWeb(),
  },
);

export * from './definitions';
export { JustWeiApkUpdater };  